import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/logo.png';
import Menu from './Menu';
import { LanguageSwitcher } from '../ui';
import { Mail, Phone } from 'lucide-react';
import { useTranslation } from '../../context/LanguageContext';

const Header = ({ onLogin }) => {
    const { t } = useTranslation();
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 10);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <header className={`sticky top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-lg shadow-lg' : 'bg-white shadow-sm'}`}>
            {/* Top bar */}
            <div className="bg-gradient-to-r from-cabaza-purple via-cabaza-purple to-cabaza-pink text-white text-xs py-1.5">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
                    <div className="hidden sm:flex items-center gap-4">
                        <a href="mailto:info@cabaza.be" className="flex items-center gap-1.5 hover:text-purple-100 transition-colors">
                            <Mail className="w-3.5 h-3.5" />
                            <span>info@cabaza.be</span>
                        </a>
                        <span className="w-px h-3 bg-white/30"></span>
                        <a href="tel:+32488123456" className="flex items-center gap-1.5 hover:text-purple-100 transition-colors">
                            <Phone className="w-3.5 h-3.5" />
                            <span>+32 488 12 34 56</span>
                        </a>
                    </div>
                    <div className="flex items-center gap-3 ml-auto">
                        {/* Promo text */}
                        <div className="hidden md:flex items-center gap-2 text-purple-100">
                            <span>{t.header?.promo || 'Le réseau social européen pour échanger'}</span>
                        </div>
                        <span className="w-px h-3 bg-white/30 hidden md:block"></span>
                        {/* Language selector */}
                        <LanguageSwitcher variant="compact" />
                    </div>
                </div>
            </div>

            {/* Main navigation */}
            <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                {/* Decorative graphic element */}
                <div className="absolute top-0 right-0 w-96 h-32 overflow-hidden pointer-events-none opacity-20">
                    <svg viewBox="0 0 400 120" className="w-full h-full" preserveAspectRatio="xMaxYMin slice">
                        <defs>
                            <linearGradient id="headerGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" stopColor="#9333ea" stopOpacity="0.4" />
                                <stop offset="50%" stopColor="#ec4899" stopOpacity="0.2" />
                                <stop offset="100%" stopColor="#9333ea" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                        <circle cx="350" cy="-20" r="100" fill="url(#headerGradient)" />
                        <circle cx="280" cy="40" r="60" fill="url(#headerGradient)" />
                        <circle cx="380" cy="80" r="40" fill="url(#headerGradient)" />
                    </svg>
                </div>
                <div className="absolute top-0 left-0 w-64 h-24 overflow-hidden pointer-events-none opacity-15">
                    <svg viewBox="0 0 250 100" className="w-full h-full" preserveAspectRatio="xMinYMin slice">
                        <defs>
                            <linearGradient id="headerGradientLeft" x1="100%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" stopColor="#ec4899" stopOpacity="0.3" />
                                <stop offset="100%" stopColor="#ec4899" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                        <path d="M0,0 Q80,60 0,100" fill="url(#headerGradientLeft)" />
                        <circle cx="30" cy="30" r="25" fill="url(#headerGradientLeft)" />
                    </svg>
                </div>

                <div className="flex justify-between items-center h-16 relative z-10">
                    <div className="flex items-center">
                        <Link to="/" className="shrink-0 flex items-center group">
                            <img
                                className="h-12 w-auto transition-transform group-hover:scale-105"
                                src={logo}
                                alt="Cabaza"
                            />
                        </Link>
                    </div>

                    <Menu />
                </div>
            </nav>
        </header>
    );
};

export default Header;
